import { ReactNode } from "react";
import { Pagination } from "antd";
import { PAGE_SIZE } from "./list";

function AdminFrame({
  title,
  meta,
  extra,
  page,
  total,
  onPage,
  children,
}: {
  title: string;
  meta: string;
  extra?: ReactNode;
  page: number;
  total: number;
  onPage: (page: number) => void;
  children: ReactNode;
}) {
  const start = total === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
  const end = Math.min(page * PAGE_SIZE, total);

  return (
    <div className="shop-page admin-page">
      <div className="admin-head">
        <div className="admin-title">
          <h2>{title}</h2>
          <span>{meta}</span>
        </div>
        <div className="admin-head-actions">{extra}</div>
      </div>
      <div className="admin-table-wrap">{children}</div>
      <div className="admin-pager">
        <span>{total ? `${start}–${end} of ${total}` : "0 results"}</span>
        <Pagination
          current={page}
          pageSize={PAGE_SIZE}
          total={total}
          showSizeChanger={false}
          hideOnSinglePage={false}
          onChange={onPage}
        />
      </div>
    </div>
  );
}

export default AdminFrame;
